<template>
  <base-page>
    <el-card style="margin: 5px 0px 5px 0px">
      <el-collapse accordion style="border: none">
        <el-collapse-item name="1" style="border: none">
          <template slot="title">
            <div slot="header" class="clearfix">
              <titlu-pagina
                Titlu="Raport grad ocupare saptamanal"
                @on_add_clicked="show_dialog()"
                :AdaugaVisible="false"
              />
            </div>
          </template>
          <div class="filtre">
            <el-tooltip placement="bottom-end"  effect="light">
              <div slot="content">
                In intervalul selectat se cauta toate programarile (cu status dechis) cu filtre. <br/>
                 <i>Total zile</i> = numarul de zile in care a gasit programari care corespund filtrelor.<br/>
                 <i>Media</i> = total programari / total zile.<br/>
                 Culorile aferente fiecarei zi a saptamanii sunt de la rosu la verde, verde insemnand ziua cu cea mai mica medie saptamanala
                </div>
              <i class="el-icon-info" style="font-size: 17px;color:#409EFF"></i>
            </el-tooltip>
            <el-form @submit.prevent="refresh_info()">
              <el-row style="margin: 10px" class="input-group">
                <el-col class="input-element">
                  <el-form-item label="Tip auto" size="mini">
                    <el-select v-model="Filters.TipAuto" class="full-width" @change="refresh_info()">
                      <el-option label="Toate" value="-1"/>
                      <el-option label="Normal" value="Normal"/>
                      <el-option label="SUV" value="SUV"/>
                      <el-option label="Autoutilitar" value="Autoutilitar"/>
                      <el-option label="Supercar" value="Supercar"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>           
                <el-col class="input-element">
                  <el-form-item label='Centru productie' size="mini">
                      <el-select class='full-width' v-model='Filters.IdCentruProductie' filterable @change="refresh_info()" >
                          <el-option label='Toate' value='-1'/>
                          <el-option v-for='item in Info.centre_productie' :key="'centre_productie' + item.Id" :label='item.Nume' :value='item.Id'/>
                      </el-select>
                  </el-form-item>
                </el-col>
                <el-col class="input-element">
                  <el-form-item label='Serviciu programator' size="mini">
                      <el-select class='full-width' v-model='Filters.IdServiciuProgramator' filterable @change="refresh_info()">
                          <el-option label='Toate' value='-1'></el-option>
                          <el-option v-for='item in Info.servicii_programator' :key="'serviciu_programator' + item.Id" :label='item.Nume' :value='item.Id'/>
                      </el-select>
                  </el-form-item>
                </el-col>
                <el-col class="input-element">
                  <el-form-item label='Interval' size="mini">
                  <br>
                    <el-date-picker v-model="Filters.Data" :picker-options="datePickerOptions" type="daterange" range-separator="-" start-placeholder="Start" end-placeholder="Stop" format="dd/MM/yyyy" value-format="yyyy-MM-dd" @change="refresh_info()"/>
                  </el-form-item>
                </el-col>
                <el-col class="input-element">
                  <el-form-item label='Hotel' size="mini">
                    <el-select class='full-width' v-model='Filters.Hotel' filterable @change="refresh_info()" >
                      <el-option label='Toate' value='-1'></el-option>
                      <el-option label='Da' value='1'></el-option>
                      <el-option label='Nu' value='0'></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <!-- <el-col :md="24">
                  <el-button type="primary" native-type="submit" @click="refresh_info()" size="mini">Aplica</el-button>
                  <el-button type="danger" native-type="submit" @click="reset()" size="mini">Reseteaza</el-button>
                </el-col> -->
              </el-row>
            </el-form>
          </div>
        </el-collapse-item>
      </el-collapse>
    </el-card>
    <el-card style="margin: 5px 0px 5px 0px">
      <LineChartGenerator
      :chart-options="chartOptions"
      :chart-data="chartData"
      :chart-id="chartId"
      :dataset-id-key="datasetIdKey"
      :plugins="plugins"
      :css-classes="cssClasses"
      :styles="styles"
      :width="width"
      :height="height"
    />
    </el-card>

  </base-page>
</template>

<script>
import settings from "@/backend/LocalSettings";
import BasePage from "@/pages/Admin/BasePage";
import TitluPagina from "@/widgets/TitluPagina";
import moment from 'moment';
import { Line as LineChartGenerator } from 'vue-chartjs/legacy'

import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  LineElement,
  LinearScale,
  CategoryScale,
  PointElement
} from 'chart.js'

ChartJS.register(
  Title,
  Tooltip,
  Legend,
  LineElement,
  LinearScale,
  CategoryScale,
  PointElement
)


export default {
  name: "masini",
  extends: BasePage,
  components: {
    LineChartGenerator,
    "base-page": BasePage,
    "titlu-pagina": TitluPagina,
  },
  props: {
    chartId: {
      type: String,
      default: 'line-chart'
    },
    datasetIdKey: {
      type: String,
      default: 'label'
    },
    width: {
      type: Number,
      default: 400
    },
    height: {
      type: Number,
      default: 400
    },
    cssClasses: {
      default: '',
      type: String
    },
    styles: {
      type: Object,
      default: () => {}
    },
    plugins: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      datePickerOptions: settings.datePickerOptions,
      Results: [],
      DateList: [],
      Info: {
        centre_productie: [],
        servicii_programator: [],
      },
      Filters: {
        Data: [moment().startOf('month').format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')],
        Numar: "",
        DataDeschiderii: "",
        IdCentruProductie: "-1",
        IdServiciuProgramator: "-1",
        Status: "Aprobat",
        TipAnvelope: "-1",
        Id: "",
        ValoareMin: "",
        ValoareMax: "",        
        DurataMin: "",
        DurataMax: "",
        Client: "",
        TipAuto: "-1",
        Hotel: "-1",
      },
      OrderBy: {},
      PaginationInfo: {
        Page: 1,
        PerPage: 50,
        RowCount: 0,
        PageSizes: [10, 25, 50, 100, 200],
      },
      chartData: {
        labels: [
          '9-10',
          '10-11',
          '11-12',
          '12-13',
          '13-14',
          '15-16',
          '16-17',
          '17-18',
          '18-19',
        ],
        datasets: [
          {
            label: 'Luni',
            backgroundColor: 'black',
            data: [0, 0,0, 0,0, 0, 0, 0, 0, 0,0,0]
          }
          ,{
            label: 'Marti',
            backgroundColor: 'black',
            data: [0, 0,0, 0,0, 0, 0, 0, 0, 0,0,0]
          }
          ,{
            label: 'Miercuri',
            backgroundColor: 'black',
            data: [0, 0,0, 0,0, 0, 0, 0, 0, 0,0,0]
          }
          ,{
            label: 'Joi',
            backgroundColor: 'black',
            data: [0, 0,0, 0,0, 0, 0, 0, 0, 0,0,0]
          }
          ,{
            label: 'Vineri',
            backgroundColor: 'black',
            data: [0, 0,0, 0,0, 0, 0, 0, 0, 0,0,0]
          }
          ,{
            label: 'Sambata',
            backgroundColor: 'black',
            data: [0, 0,0, 0,0, 0, 0, 0, 0, 0,0,0]
          } 
          ,{
            label: 'Duminica',
            backgroundColor: 'black',
            data: [0, 0,0, 0,0, 0, 0, 0, 0, 0,0,0]
          }
        ],
        
      },
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        pointRadius: 5,
      pointHoverRadius: 7,
      elements: {
        line: {
            tension: 0.2
        }
    },
        scales: {
            y: {
                ticks: {
                  stepSize: 1,
                    callback: function(value, index, ticks) {
                      if (value == 0) return 'Liber';
                      if (value == 1) return '1 programare';
                      else  return  value + ' programari';
                    }
                }
            }
        },
        plugins: {
          tooltip: {
            callbacks: {
              // title: function(t, d) {
              //   console.log(t)
              //   return t[0].label + " " + t[0].dataset.label;
              // },
              label: function(t, index) {
                var multistringText = [" " + t.dataset.label.split(" (")[0]];
                multistringText.push('Total zile in raport: ' + t.dataset.numar_zile);
                multistringText.push('Medie programari pe zi: ' + t.dataset.medie_pe_zi);
                return multistringText;
              }
            },
            legend: {
              display: true
            },
          }
        }
        
      }
    };
  },
  methods: {
  
    async get_info() {
      var response = await this.post("receptie/devize/get_info_raport_grad_ocupare");
      this.Info.centre_productie = response.centre_productie;
      this.Info.servicii_programator = response.servicii_programator;
      this.refresh_info();
    },

    async refresh_info() {
      var response = await this.post("receptie/devize/get_raport_grad_ocupare", {
        Filters: this.Filters,
      });

      // response.raspuns.forEach(element => {
      //   if(this.chartData.datasets == element.
        
      // });

      // console.table(JSON.parse(JSON.stringify(this.chartData.datasets)))
      this.chartData.datasets = response.raspuns;
      // console.table(this.chartData.datasets)
      
    },
    reset() {
      this.Filters = {
        Data: [moment().startOf('month').format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')],
        Numar: "",
        DataDeschiderii: "",
        IdCentruProductie: "-1",
        IdServiciuProgramator: "-1",
        Status: "Aprobat",
        TipAnvelope: "-1",
        Id: "",
        ValoareMin: "",
        ValoareMax: "",        
        DurataMin: "",
        DurataMax: "",
        Client: "",
        TipAuto: "-1",
        Hotel: "-1",
      };
      this.refresh_info();
    },

  },

  created() {
    if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
      this.device = "phone"
    } else this.device = "computer"
  },
  mounted() {
    this.select_menu_item("raport_grad_ocupare");

    if (!this.$has_right("Management")) {
      this.$router.push("/no-rights");
      return;
    }
    this.base_url = settings.BASE_URL;
    this.get_info();
  },
};
</script>

<style lang="less" scoped>
.top50 {
  margin-top: 20px;
}

.input-group {
  display: flex;
  align-items: flex-start;
  // justify-content: space-between;
}

.filtre {
  .el-input-number {
    width: 100% !important;
  }
}
.input-element {
  width: 18%;
  margin-right: 2%;
}

@media only screen and (max-width: 600px) {
  .input-element {
    width: 80%;
  }

  .input-group {
    margin: 10px;
  }

  .el-tooltip__popper {
    width: 90%;
  }

  .el-date-editor--daterange.el-input__inner {
    width: 300px;
  }

  .el-picker-panel__body {
    display: flex;
    flex-direction: column;
  }
}
</style>
